/**
 *  All api related to articles
 */

import _ from 'lodash'
import { CancelToken } from 'axios'
import { OmnitechApi } from '../../api'
import { cancelRequest } from '../../helpers'
import { isErrorExist, convertResponseToErrorObject } from '../../omnitech-error'

export function fetchArticles(options = {}) {
  const { page = 1, ...others } = options
  const params = {
    page,
    ...others
  }
  const source = CancelToken.source()
  cancelRequest.add(
    'fetchArticles',
    () => source.cancel('fetchArticles: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: 'articles',
      method: 'get',
      params,
      cancelToken: source.token
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      articles: data.articles,
      pagination: data.articlesPagination,
      next: _.get(data, 'articlesPagination.nextPage') > page
        ? () => fetchArticles({ page: page + 1, ...others })
        : null,
      count: _.get(data, 'articlesPagination.totalCount')
    }))
}

export function fetchArticle(options = {}) {
  const { id, ...params } = options
  const source = CancelToken.source()
  cancelRequest.add(
    'fetchArticle',
    () => source.cancel('fetchArticle: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: `articles/${id}`,
      method: 'get',
      params,
      cancelToken: source.token
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      article: data.article
    }))
}

export function fetchArticlesTags(options = {}) {
  const { id, ...params } = options
  const source = CancelToken.source()
  cancelRequest.add(
    'fetchArticle',
    () => source.cancel('fetchArticle: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: `articles/tags`,
      method: 'get',
      params,
      cancelToken: source.token
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      tags: data.tags
    }))
}
